import { PATTERN_TYPES, PATTERNS_FIELDS } from '@/constants';

export default {
  patterns: 'Modèles',
  myPatterns: 'Mes modèles',
  corporatePatterns: 'Modèles partagés',
  addRule: 'Ajouter une règle',
  addGroup: 'Ajouter un groupe',
  removeRule: 'Supprimer la règle',
  advancedEditor: 'Éditeur avancé',
  simpleEditor: 'Éditeur simple',
  fixJsonWithAi: 'Corriger le JSON avec l\'IA',
  noData: 'Aucun modèle. Cliquez sur \'@:pattern.addGroup\' pour ajouter des champs au modèle',
  noDataDisabled: 'Aucun modèle.',
  alarmsCount: '{alarmsCount} alarmes trouvées',
  entitiesCount: '{entitiesCount} entités trouvées',
  alarmsEntitiesCount: '{alarmsCount} alarmes et {entitiesCount} entités trouvées',
  searchTime: 'Temps de recherche : <strong>{duration}</strong>',
  patternAlarms: 'Alarmes de modèle',
  patternEntities: 'Entités de modèle',
  found: 'trouvé : {message} / temps de recherche <strong>{searchTime}</strong>',
  alarmFound: '<strong>{count} alarme</strong> | <strong>{count} alarmes</strong>',
  entityFound: '<strong>{count} entité</strong> | <strong>{count} entités</strong>',
  types: {
    [PATTERN_TYPES.alarm]: 'Modèle d\'alarme',
    [PATTERN_TYPES.entity]: 'Modèle d\'entité',
    [PATTERN_TYPES.pbehavior]: 'Modèle de comportements périodiques',
    [PATTERN_TYPES.serviceWeather]: 'Modèle de météo des services',
  },
  patternsFields: {
    [PATTERNS_FIELDS.alarm]: 'Alarme',
    [PATTERNS_FIELDS.entity]: 'Entité',
    [PATTERNS_FIELDS.pbehavior]: 'Comportements périodiques',
    [PATTERNS_FIELDS.event]: 'Événement',
    [PATTERNS_FIELDS.totalEntity]: 'Entité totale',
    [PATTERNS_FIELDS.serviceWeather]: 'Météo des services',
  },
  patternsMessage: '{patterns} modèle | {patterns} modèles',
  notDefinedType: 'Le type sélectionné diffère du type défini dans les informations d\'entité',
  tryOptimization: 'Essayer l\'optimisation',
  tryOptimizationHint: 'Essayez d\'optimiser la Regexp pour accélérer la requête<br><span class="font-weight-regular">Les requêtes Regexp fonctionnent généralement plus lentement que les requêtes normales.</span>',
  optimizationInProgress: 'Optimisation en cours...',
  optimizationFailed: 'Optimisation échouée : {reason}',
  cancelOptimization: 'Annuler l\'optimisation',
  patternsCreationInProgress: 'Création des modèles en cours...',
  cancelPatternsCreation: 'Annuler la création des modèles',
  patternsUpdateInProgress: 'Mise à jour des modèles en cours...',
  cancelPatternsUpdate: 'Annuler la mise à jour des modèles',
  optimizationCancelled: 'L\'optimisation a été annulée',
  suggestions: 'Suggestions',
  rejectAllSuggestions: 'REJETER TOUTES LES SUGGESTIONS',
  foundEntities: 'trouvé: <strong>{count} entités</strong>',
  sameEntities: 'entités identiques',
  seeRecordsComparison: 'Comparaison des résultats',
  conditionsOptimized: 'Les expressions <strong>réguliéres suivantes</strong> ont été optimisées :',
  applyThisSuggestion: 'APPLIQUER CETTE SUGGESTION',
  optimizationSuggestionsWasntFound: 'Aucune suggestion d\'optimisation <strong>regexp</strong> trouvée',
  errors: {
    ruleRequired: 'Veuillez ajouter au moins une règle',
    groupRequired: 'Veuillez ajouter au moins un groupe',
    invalidPatterns: 'Les modèles ne sont pas valides ou il y a un champ de modèle désactivé',
    countOverLimit: 'Le modèle que vous avez défini cible {count} éléments. Cela peut affecter les performances, en êtes-vous sûr ?',
    existExcluded: 'Les règles incluent la règle exclue.',
    required: 'Au moins un modèle doit être défini. Veuillez définir des modèles de filtre pour la règle',
  },
};
